import { AppContext } from "../../../App.context";
import { useContext, useEffect } from "react";

export function useDownloadPages(args: DownloadImagesArgs) {
    const { sw } = useContext(AppContext);
    const { issue } = args;

    useEffect(() => {
        if (!issue) {
            return;
        }

        if (!sw) {
            return;
        }

        const isSupported = isReplicaSupported(issue);
        if (!isSupported) {
            return;
        }

        const { articles } = issue;
        const pages = getPagesFromArticles(articles);

        console.log(`DOWNLOAD BACKGROUND REPLICA PAGES`, pages);
        // TODO Disable replica pages

        /*sw.postMessage({
            type: 'DOWNLOAD_BACKGROUND_REPLICA_PAGES',
            payload: {
                pages,
                IssueID: issue.id,
            },
        });*/

    }, [issue, sw]);
}

interface DownloadImagesArgs {
    issue: any;
}

export function isReplicaSupported(issue: any) {
    const { articles } = issue;
    for (const article of articles) {
        const { replica } = article;
        if (!replica) {
            continue;
        }

        if (!replica.length) {
            continue;
        }

        return true;
    }

    return false;
}

function getPagesFromArticles(articles: Array<any>) {
    const pages = articles
        .reduce((acc: Array<any>, article: any) => {
            const { replica } = article;
            if (!replica) {
                console.log(
                    `THIS ARTICLE IS THE PROBLEM: ${article.id} \n`,
                    article,
                );
                return acc;
            }
            for (const item of replica) {
                item.articleId = article.id;
                acc.push(item);
            }
            return acc;
        }, [])
        .sort((a: any, b: any) => a.index - b.index)
        .reduce(removeDuplicatePages, { pagesSet: new Set(), pages: [] }).pages;

    const result = new Set();
    for (const { image } of pages) {
        result.add(image);
    }

    return [...result];
}

function removeDuplicatePages(
    acc: { pagesSet: Set<string>; pages: Array<any> },
    page: any,
) {
    const { pagesSet, pages } = acc;
    const { name } = page;
    if (pagesSet.has(name)) {
        return acc;
    }

    pagesSet.add(name);
    pages.push(page);

    return {
        pagesSet,
        pages,
    };
}